import api from './api';

/**
 * Servicio para la gestión de logros en PostgreSQL
 * Maneja tanto logros individuales como especiales
 */

const postgresAchievementService = {
  // Obtener todos los logros (individuales y especiales)
  getAll: async () => {
    try {
      const response = await api.get('/postgres/achievements');
      return response.data;
    } catch (error) {
      console.error('Error al obtener todos los logros:', error);
      throw error;
    }
  },

  // Obtener logros individuales
  getLogrosIndividuales: async () => {
    try {
      const response = await api.get('/postgres/achievements/individuales');
      return response.data;
    } catch (error) {
      console.error('Error al obtener logros individuales:', error);
      throw error;
    }
  },

  // Obtener logros especiales
  getLogrosEspeciales: async () => {
    try {
      const response = await api.get('/postgres/achievements/especiales');
      return response.data;
    } catch (error) {
      console.error('Error al obtener logros especiales:', error);
      throw error;
    }
  },

  // Crear logro individual
  createLogroIndividual: async (data) => {
    try {
      const response = await api.post('/postgres/achievements/individuales', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear logro individual:', error);
      throw error;
    }
  },

  // Crear logro especial
  createLogroEspecial: async (data) => {
    try {
      const response = await api.post('/postgres/achievements/especiales', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear logro especial:', error);
      throw error;
    }
  },

  // Actualizar logro individual
  updateLogroIndividual: async (id, data) => {
    try {
      const response = await api.put(`/postgres/achievements/individuales/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar logro individual:', error);
      throw error;
    }
  },

  // Actualizar logro especial
  updateLogroEspecial: async (id, data) => {
    try {
      const response = await api.put(`/postgres/achievements/especiales/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar logro especial:', error);
      throw error;
    }
  },

  // Eliminar logro individual (si se necesita en el futuro)
  deleteLogroIndividual: async (id) => {
    try {
      const response = await api.delete(`/postgres/achievements/individuales/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar logro individual:', error);
      throw error;
    }
  },

  // Eliminar logro especial (si se necesita en el futuro)
  deleteLogroEspecial: async (id) => {
    try {
      const response = await api.delete(`/postgres/achievements/especiales/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar logro especial:', error);
      throw error;
    }
  },
  // ===== NIVELES =====

  // Obtener niveles (opcionalmente filtrar por tipo_torneo)
  getNiveles: async (tipoTorneo) => {
    try {
      const params = tipoTorneo ? { tipo_torneo: tipoTorneo } : {};
      const response = await api.get('/postgres/achievements/niveles', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener niveles:', error);
      throw error;
    }
  },

  // Actualizar nivel
  updateNivel: async (id, data) => {
    try {
      const response = await api.put(`/postgres/achievements/niveles/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar nivel:', error);
      throw error;
    }
  },

  // Crear nivel
  createNivel: async (data) => {
    try {
      const response = await api.post('/postgres/achievements/niveles', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear nivel:', error);
      throw error;
    }
  }
};

export default postgresAchievementService;
